import React from 'react';
import { Route } from 'react-router-dom';

import RenderContent from 'app/components/layout/RenderContent';
import HeaderThin from 'app/components/layout/HeaderThin';

import SubmitForfeit from './components/SubmitForfeit';
import SubmitForfeitCovid from './components/SubmitForfeitCovid';
import SelectForfeitCovid from './components/SelectForfeitCovid';
import ConfirmZeroDollarForfeitCovid from './components/ConfirmZeroDollarForfeitCovid';
import SelectForfeit from './components/SelectForfeit';

interface IForfeitsLayoutProps {
  match: any;
}
export default class ForfeitsLayout extends React.Component<
IForfeitsLayoutProps,
{}
> {
  static defaultProps: IForfeitsLayoutProps = {
    match: undefined,
  };

  render() {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="row">
          <div className="col">
            <HeaderThin title="Submit Forfeit" divider />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Route
              exact
              path={['/forfeit/select']}
              render={() => <SelectForfeit {...this.props} />}
            />
            <Route
              exact
              path={['/forfeit/covid/select']}
              render={() => <SelectForfeitCovid {...this.props} />}
            />
            <Route
              exact
              path={['/forfeit/:paymentEventId/:groupId/submit']}
              render={() => <SubmitForfeit {...this.props} />}
            />
            <Route
              exact
              path={['/forfeit/:paymentEventId/:groupId/submit/covid']}
              render={() => <SubmitForfeitCovid {...this.props} />}
            />
            <Route
              exact
              path={['/forfeit/confirm/covid/:forfeitId']}
              render={() => <ConfirmZeroDollarForfeitCovid {...this.props} />}
            />
          </div>
        </div>
      </RenderContent>
    );
  }
}
